<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
  </div>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
// import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
// import { isEmpty } from 'lodash'

export default {
  name: 'WepHeader',
  components: {
    VRuntimeTemplate
  },
  props: {
    isHeaderImg: {
      type: Boolean,
      default: true
    },
    isEnter: {
      type: Boolean,
      default: false
    },
    menuSeq: {
      type: Number,
      default: 1
    },
    routerName: {
      type: String,
      default: 'index'
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      includeHtml: '',
      isHome: true,
      isOnAir: false,
      langCd: localStorage.getItem('language'),
      langNm: '',
      moLangNm: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      langList: [],
      currLangCd: 'ko',
      loginNm: '',
      wepSets: this.getStore('mmpAuth').state.wepSets,
      loginType: 'L',
      ptptAplTyp: this.getStore('mmpAuth').state.wepSets.ptptAplTyp
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
    // 'includeTemplate': {
    //   handler: function (nVal, oVal) {
    //   }
    // }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  async created () {
    this.getEmptyTemplate('wepHeader.html')
    this.fnSetLang()
    this.getLangList()
    this.getMainType()
  },
  beforeUpdate () {
  },
  methods: {
    fnSetLang () {
      if (localStorage.getItem('language') === 'en') {
        this.langNm = 'EN'
        this.moLangNm = 'English'
      } else if (localStorage.getItem('language') === 'cn') {
        this.langNm = 'CN'
        this.moLangNm = '简体中文'
      } else if (localStorage.getItem('language') === 'vi') {
        this.langNm = 'VI'
        this.moLangNm = 'Tiếng Việt'
      } else {
        this.langNm = 'KO'
        this.moLangNm = '한국어'
      }

      if (window.vue.getStore('mmpAuth').state.isMain) {
        this.langNm = this.moLangNm
      }
    },
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        this.includeHtml = res
      })
    },
    fnHome () {
      // this.getTemplate('includeHtml/wepMainHome.html', '0', 'index')
      this.getTemplate('wepMainHome.html', '0', 'index')
    },
    fnFaq () {
      // this.getTemplate('includeHtml/wepFaq.html', '0', 'faq')
      this.getTemplate('wepFaq.html', '0', 'faq')
    },
    fnForum () {
      // this.getTemplate('includeHtml/wepForum.html', '0', 'forum')
      this.getTemplate('wepForum.html', '0', 'forum')
    },
    openLangList () {
      document.querySelectorAll('.header-lang')[0].classList.toggle('opened-lang')
    },
    closeLangList () {
      document.querySelectorAll('.header-lang')[0].classList.remove('opened-lang')
    },
    openMenuList () {
      document.querySelectorAll('.header')[0].classList.toggle('opened-menu')
    },
    fnLangReload (code) {
      localStorage.setItem('language', code)
      location.reload()
    },
    async getLangList () {
      this.currLangCd = localStorage.getItem('language')
      let params = {wepId: this.getStore('mmpAuth').state.saveId}
      var listLangResult = await this.$http.mmp.laingList(this, params)
      this.langList = listLangResult.data.data
    },
    async fnAlert (msg) {
      let alertParams = { title: this.$t('WEP00008'), contents: msg, okBtnNm: this.$t('WEP00006') }
      let confirmRes = await this.$popup.alert(this.$el, alertParams)
      if (confirmRes) {}
    },
    async getMainType () {
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data

      if (this.wepSets.mocktUseYn === 'Y' && currDay >= this.wepSets.mocktStartDtm && currDay <= this.wepSets.mocktEndDtm) {
        this.loginType = 'M'
      } else if (currDay >= this.wepSets.videoTrnsStartDtm && currDay <= this.wepSets.videoTrnsEndDtm) {
        this.loginType = 'L'
      } else if (currDay >= this.wepSets.ptptAplStartDtm && currDay <= this.wepSets.ptptAplEndDtm && this.ptptAplTyp === 'PO') {
        this.loginType = 'E'
      }
    },
    async fnLogin () {
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data

      if (currDay >= this.wepSets.videoTrnsStartDtm && currDay <= this.wepSets.videoTrnsEndDtm) {
        if (this.isLogin) {
          this.getTemplate('wepOnAir.html', '0', 'onAir')
        } else {
          this.getTemplate('wepEnter.html', '0', 'enter')
        }
      } else if (this.wepSets.mocktUseYn === 'Y' && currDay >= this.wepSets.mocktStartDtm && currDay <= this.wepSets.mocktEndDtm) {
        if (this.isLogin) {
          this.getTemplate('wepOnAir.html', '0', 'onAir')
        } else {
          this.getTemplate('wepEnter.html', '0', 'enter')
        }
      } else {
        this.fnAlert(this.$t('WEP00019'))
      }
    },
    async fnSurvey () {
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data

      if (currDay >= this.wepSets.ptptAplStartDtm && currDay <= this.wepSets.ptptAplEndDtm) {
        this.getTemplate('wepSurvey.html', '1')
        this.getTemplate('wepRegister.html', '2')
        this.getTemplate('wepComplete.html', '3')
        this.getTemplate('wepConfirm.html', '4')
        this.getTemplate('wepResult.html', '5' )
        this.getTemplate('wepResult2.html', '6', 'surveyConfirm')
      } else {
        this.fnAlert(this.$t('WEP00020'))
      }
    },
    async logOut () {
      let alertParams = { title: this.$t('WEP00021'), contents: '', okBtnNm: this.$t('WEP00006'), cancelBtnNm: this.$t('WEP00007') }
      let confirmRes = await this.$popup.confirm(this.$el, alertParams)
      if (confirmRes) {
        this.$utils.user.logout()
        this.getTemplate('wepMainHome.html', '0', 'index')
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/WepHeader.vue